import * as api from '../../api';
import HeroComponent from './Hero';
import InputOnly from './InputOnly';
import { AssistantRenderProps } from './common';

export const ModalitiesConfigurationRoutes: {
  [key in api.Assistant.Modality]: {
    path: string;
    component: (props: AssistantRenderProps) => JSX.Element;
  };
} = {
  [api.Assistant.Modality.Hero]: {
    path: '/hero',
    component: (props) => <HeroComponent {...props} />,
  },
  [api.Assistant.Modality.HeroCompact]: {
    path: '/hero-compact',
    component: (props) => <HeroComponent {...props} compact />,
  },
  [api.Assistant.Modality.Input]: {
    path: '/input',
    component: (props) => <InputOnly {...props} />,
  },
  [api.Assistant.Modality.TakeoverButton]: {
    path: '',
    component: (props) => <></>,
  },
};
